<template>
  <div class="page2-main">
    <div class="filter-main">
      筛选条件：
      <div class="filter-item">
        <label>h指数：</label>
        <el-select v-model="htIndex" placeholder="请选择" clearable @change="handleHtIndexSearch">
          <el-option v-for="item in htIndexList" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="filter-item">
        <label>被引用次数：</label>
        <el-select v-model="citedByCount" placeholder="请选择" clearable @change="handleCitedByCountSearch">
          <el-option v-for="item in citedByCountList" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="filter-item">
        <label>作品数量：</label>
        <el-select v-model="worksCount" placeholder="请选择" clearable @change="handleWorksCountSearch">
          <el-option v-for="item in worksCountList" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </div>
    </div>
    <div class="search_total">
      <p class="total">
        <span>{{ listTotal }}</span
        >条作者数据
      </p>
    </div>
    <subject-list-skeleton v-if="loading" variant="author" />
    <ul v-else class="right-list">
      <li v-for="(item, index) in authorList" :key="index">
        <span class="right_index">{{ (pageNo - 1) * pageSize + index + 1 }}</span>
        <div class="right-content">
          <div class="title" @click="toAuthorDetail(item.sid)" v-safe-html="item.authorName"></div>
          <div class="num">
            <span><i class="el-icon-s-data"></i>H-index：{{ item.hindex }}</span>
            <span><i class="el-icon-s-comment"></i>论文数：{{ item.worksCount }}</span>
            <span><i class="el-icon-share"></i>引用数：{{ item.citedByCount }}</span>
          </div>
          <p v-if="item.lastKnownInstitutionName">所属机构：<span v-safe-html="item.lastKnownInstitutionName"></span></p>
          <p v-if="item.primayConcepts && item.primayConcepts.length > 0">
            研究领域：<span v-for="(element, idx) in item.primayConcepts" :key="idx"> <span v-safe-html="element"></span><span v-if="idx < item.primayConcepts.length - 1">；</span></span>
          </p>
        </div>
      </li>
    </ul>
    <div class="noData" v-if="total <= 0 && !loading">
      <img src="../../assets/images/noData.png" />
    </div>
    <el-pagination v-if="!loading" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[10, 20, 30, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" hide-on-single-page> </el-pagination>
  </div>
</template>

<script>
import SubjectListSkeleton from "@/components/SubjectListSkeleton.vue";

export default {
  components: { SubjectListSkeleton },
  data() {
    return {
      loading: true,
      pageSize: 10,
      pageNo: 1,
      total: 0,
      listTotal: 0,
      authorList: [],
      keyWords: "",

      htIndexList: [
        {
          name: "全部",
          value: "-",
        },
        {
          name: "h指数:<10",
          value: "-9",
        },
        {
          name: "h指数:10-19",
          value: "10-19",
        },
        {
          name: "h指数:20-29",
          value: "20-29",
        },
        {
          name: "h指数:30-39",
          value: "30-39",
        },
        {
          name: "h指数:40-49",
          value: "40-49",
        },
        {
          name: "h指数:50-59",
          value: "50-59",
        },
        {
          name: "h指数:>=60",
          value: "60-",
        },
      ],
      htIndex: "",
      htIndexStart: "",
      htIndexEnd: "",

      citedByCountList: [
        {
          name: "被引量大于1000",
          value: "1000-",
        },
        {
          name: "被引量500-1000",
          value: "500-1000",
        },
        {
          name: "被引量100-500",
          value: "100-500",
        },
        {
          name: "被引量50-100",
          value: "50-100",
        },
        {
          name: "被引量10-50",
          value: "10-50",
        },
      ],
      citedByCount: "",
      citedByCountStart: "",
      citedByCountEnd: "",

      worksCountList: [
        {
          name: "作品数量大于100",
          value: "100-",
        },
        {
          name: "作品数量50-100",
          value: "50-100",
        },
        {
          name: "作品数量30-50",
          value: "30-50",
        },
        {
          name: "作品数量10-30",
          value: "10-30",
        },
        {
          name: "作品数量小于10",
          value: "-10",
        },
      ],
      worksCount: "",
      worksCountStart: "",
      worksCountEnd: "",
    };
  },
  props: {
    parentData: {
      type: String,
      default: "",
    },
    parentConceptId: {
      type: String,
      default: "",
    },
  },
  watch: {
    parentData(val) {
      this.pageNo = 1;
      this.keyWords = val;
      this.getAuthorList();
    },
  },
  mounted() {
    this.keyWords = this.parentData;
    this.getAuthorList();
  },
  methods: {
    handleHtIndexSearch(val) {
      this.htIndex = val;
      let _val = this.htIndex.split("-");
      this.htIndexStart = _val[0];
      this.htIndexEnd = _val[1] ? _val[1] : "";
      this.pageNo = 1;
      this.getAuthorList();
    },
    handleCitedByCountSearch(val) {
      this.citedByCount = val;
      let _val = this.citedByCount.split("-");
      this.citedByCountStart = _val[0];
      this.citedByCountEnd = _val[1] ? _val[1] : "";
      this.pageNo = 1;
      this.getAuthorList();
    },
    handleWorksCountSearch(val) {
      this.worksCount = val;
      let _val = this.worksCount.split("-");
      this.worksCountStart = _val[0] ? _val[0] : "";
      this.worksCountEnd = _val[1] ? _val[1] : "";
      this.pageNo = 1;
      this.getAuthorList();
    },
    clearSearch() {
      this.htIndex = "";
      this.htIndexStart = "";
      this.htIndexEnd = "";

      this.worksCount = "";
      this.worksCountStart = "";
      this.worksCountEnd = "";

      this.citedByCountStart = "";
      this.citedByCountEnd = "";
      this.citedByCount = "";
      this.pageNo = 1;

      this.getAuthorList();
    },
    getAuthorList() {
      let postBody = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        keyWords: this.keyWords,
        conceptId: this.parentConceptId,
        htIndexStart: this.htIndexStart,
        htIndexEnd: this.htIndexEnd,
        citedByCountStart: this.citedByCountStart,
        citedByCountEnd: this.citedByCountEnd,
        worksCountStart: this.worksCountStart,
        worksCountEnd: this.worksCountEnd,
      };
      this.loading = true;
      this.$http({
        url: "api/v1/concept/author/list",
        method: "post",
        data: postBody,
      }).then(res => {
        this.loading = false;
        this.authorList = res.data.recordList;
        this.total = res.data.recordCount > 10000 ? 10000 : res.data.recordCount;
        this.listTotal = res.data.recordCount;
      });
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getAuthorList();
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getAuthorList();
    },
    toAuthorDetail(authorSid) {
      let _url = this.$router.resolve({
        path: "/authorDetail",
        query: { authorSid: authorSid },
      });
      window.open(_url.href, "_self");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/public.scss";
.page2-main {
  .search_total {
    display: flex;
    align-items: center;
    .total {
      color: #86909c;
      span {
        color: #ff0000;
        margin-right: 5px;
      }
    }
    .search {
      margin-left: auto;
      width: 400px;
      position: relative;
      display: flex;
      align-items: center;
      ::v-deep .el-input__inner {
        border-radius: 0;
      }
      > span {
        background: #2d8cf0;
        height: 40px;
        width: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
  .right-list {
    color: #666;
    li {
      display: flex;
      padding: 20px 0;
      border-bottom: 1px dashed #eeeeee;
      .right_index {
        width: 65px;
      }
      .right-content {
        flex: 1;
        .hover {
          cursor: pointer;
          color: #2d8cf0;
          &:hover {
            color: #2d8cf0 !important;
            text-decoration: underline;
          }
        }
      }
    }
    .title {
      color: #333;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
      margin-bottom: 10px;
      &:hover {
        background-image: linear-gradient(to right, #006eb3, #2d8cf0);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        label {
          -webkit-text-fill-color: initial;
        }
      }
    }
    .num {
      margin-bottom: 8px;
      span {
        display: inline-block;
        margin-right: 15px;
        label {
          margin-left: 5px;
        }
        i {
          color: #ccc;
          margin-right: 5px;
        }
      }
    }
    p {
      margin-bottom: 8px;
    }
  }
}
</style>
